import { Navigate } from "react-router";

import { UWReviewRequired } from "@covertree/new-business-uw-decision";

import { useUwReviewStep } from "./useUwReviewStep";

export const UwReviewStep = () => {
  const { redirectTo, isLoading, variant, notes, identifiers } =
    useUwReviewStep();

  if (redirectTo) {
    return <Navigate to={redirectTo} replace />;
  }

  return (
    <UWReviewRequired
      identifiers={identifiers}
      variant={variant}
      size="small"
      isLoading={isLoading}
      notes={notes}
      recordType="endorsement"
    />
  );
};
